import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { getCustomConfig } from '~/selectors/event';
import styles from './registerForm.module.css';
import { parseCustomConfig } from '~/utils/helpers';
const TermsAndConditions = ({ customConfig }) => {
    const customPreNeedUI = customConfig?.customPreNeedUI ? parseCustomConfig(customConfig?.customPreNeedUI) : undefined;
    const registrationFormDisclaimer = customPreNeedUI?.registrationFormDisclaimer ?? undefined;
    if (registrationFormDisclaimer) {
        return (_jsx("div", { className: styles.termsAndConditions, dangerouslySetInnerHTML: { __html: registrationFormDisclaimer } }));
    }
    else {
        return (_jsxs("div", { className: styles.termsAndConditions, children: ["I agree to the", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/terms-and-conditions", target: "_blank", rel: "noreferrer", children: "T & C" }), ' ', "and", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/privacy-policy", target: "_blank", rel: "noreferrer", children: "Privacy Policy" })] }));
    }
};
const mapStateToProps = (state) => ({
    customConfig: getCustomConfig(state),
});
export default connect(mapStateToProps)(TermsAndConditions);
